import { createRoute, useParams } from "@tanstack/react-router";
import { AcceptInviteForm } from "@/components/auth/AcceptInviteForm";
import { Route as RootRoute } from "./__root";

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: "/accept-invite/$token",
  component: AcceptInviteRoute,
});

function AcceptInviteRoute() {
  const { token } = useParams({ from: "/accept-invite/$token" });
  return <AcceptInviteForm token={token} />;
}
